module.exports = __webpack_public_path__ + "img/DE02080.e1bf6ef1.png";